
export enum ModelType {
  NULAR_FLASH = 'nular_flash', // Mistral 7B (Hugging Face)
  NULAR_PRO = 'nular_pro',     // Llama 3 8B (Hugging Face)
  NULAR_O1 = 'nular_o1'        // Llama 3 8B + Reasoning Prompt (Hugging Face)
}

export enum AppLanguage {
  ENGLISH = 'en',
  ARABIC = 'ar',
  SPANISH = 'es',
  FRENCH = 'fr',
  GERMAN = 'de',
  CHINESE = 'zh'
}

export enum MediaMode {
  IMAGE = 'image',
  VIDEO = 'video'
}

export interface AppSettings {
  model: ModelType;
  language: AppLanguage;
  enableThinking: boolean; 
  enableDeepResearch: boolean;
  userMemory: string;
}

export interface ChatMessage {
  id: string;
  role: 'user' | 'model';
  text: string;
  isError?: boolean;
  timestamp: number;
  image?: string; // base64
  audio?: string; // base64
}

export interface Conversation {
  id: string;
  title: string;
  messages: ChatMessage[];
  updatedAt: number;
}

export interface ToastMessage {
  id: string;
  title: string;
  description: string;
  type: 'info' | 'success' | 'error';
}

export const TRANSLATIONS = {
  [AppLanguage.ENGLISH]: {
    newChat: "New Chat",
    settings: "Settings",
    typePlaceholder: "Ask Nular...",
    thinking: "Thinking",
    deepResearch: "Research",
    models: "Models",
    languages: "Languages",
    features: "Features",
    disclaimer: "Nular can make mistakes. Check accuracy."
  },
  [AppLanguage.ARABIC]: {
    newChat: "محادثة جديدة",
    settings: "الإعدادات",
    typePlaceholder: "اسأل نولار...",
    thinking: "تفكير",
    deepResearch: "بحث عميق",
    models: "النماذج",
    languages: "اللغات",
    features: "الميزات",
    disclaimer: "نولار قد يخطئ. تحقق من الدقة."
  },
  [AppLanguage.SPANISH]: {
    newChat: "Nueva Chat",
    settings: "Ajustes",
    typePlaceholder: "Pregunta a Nular...",
    thinking: "Pensamiento",
    deepResearch: "Investigación",
    models: "Modelos",
    languages: "Idiomas",
    features: "Funciones",
    disclaimer: "Nular puede cometer errores."
  },
  [AppLanguage.FRENCH]: {
    newChat: "Nouveau Chat",
    settings: "Paramètres",
    typePlaceholder: "Demandez à Nular...",
    thinking: "Réflexion",
    deepResearch: "Recherche",
    models: "Modèles",
    languages: "Langues",
    features: "Fonctionnalités",
    disclaimer: "Nular peut faire des erreurs."
  },
  [AppLanguage.GERMAN]: {
    newChat: "Neuer Chat",
    settings: "Einstellungen",
    typePlaceholder: "Frag Nular...",
    thinking: "Denken",
    deepResearch: "Forschung",
    models: "Modelle",
    languages: "Sprachen",
    features: "Funktionen",
    disclaimer: "Nular kann Fehler machen."
  },
  [AppLanguage.CHINESE]: {
    newChat: "新对话",
    settings: "设置",
    typePlaceholder: "询问 Nular...",
    thinking: "思考",
    deepResearch: "研究",
    models: "模型",
    languages: "语言",
    features: "功能",
    disclaimer: "Nular 可能会犯错。"
  }
};
